export interface Category {
  id: string;
  name: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20premium%20designer%20sneakers%20and%20casual%20shoes%20neatly%20arranged%20on%20a%20clean%20light%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20neutral%20beige%20and%20cream%20background%2C%20editorial%20product%20photography%20style%20with%20warm%20tones%20and%20minimal%20shadows&width=400&height=400&seq=cat-img-shoes&orientation=squarish',
  },
  {
    id: 'hoodies-sweaters',
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20oversized%20hoodies%20and%20knit%20sweaters%20folded%20and%20stacked%20elegantly%20on%20a%20minimalist%20display%2C%20soft%20cream%20and%20terracotta%20tones%2C%20warm%20natural%20light%20from%20above%2C%20clean%20editorial%20fashion%20photography%20with%20organic%20textures&width=400&height=400&seq=cat-img-hoodies&orientation=squarish',
  },
  {
    id: 't-shirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20curated%20selection%20of%20premium%20cotton%20t-shirts%20in%20neutral%20shades%20displayed%20on%20wooden%20hangers%20against%20a%20warm%20beige%20wall%2C%20soft%20golden%20afternoon%20light%2C%20editorial%20lifestyle%20fashion%20photography%20style%20with%20organic%20composition&width=400&height=400&seq=cat-img-tshirts&orientation=squarish',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20designer%20jackets%20including%20bomber%20and%20denim%20styles%20displayed%20on%20a%20minimalist%20clothing%20rack%2C%20warm%20earth%20tone%20backdrop%2C%20soft%20ambient%20lighting%2C%20editorial%20fashion%20photography%20with%20clean%20composition%20and%20warm%20neutral%20palette&width=400&height=400&seq=cat-img-jackets&orientation=squarish',
  },
  {
    id: 'pants-shorts',
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20tailored%20trousers%20and%20casual%20shorts%20neatly%20folded%20on%20a%20marble%20surface%2C%20warm%20neutral%20tones%20of%20beige%20and%20taupe%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%20style%20with%20elegant%20minimalist%20composition&width=400&height=400&seq=cat-img-pants&orientation=squarish',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20premium%20caps%20and%20beanies%20arranged%20artistically%20on%20a%20warm%20wooden%20shelf%2C%20soft%20natural%20lighting%2C%20cream%20and%20olive%20tones%2C%20editorial%20fashion%20accessory%20photography%20with%20clean%20minimal%20background&width=400&height=400&seq=cat-img-headwear&orientation=squarish',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Matching%20coordinated%20outfit%20sets%20including%20tops%20and%20bottoms%20displayed%20flat%20lay%20on%20a%20soft%20linen%20surface%2C%20harmonious%20earth%20tone%20color%20palette%2C%20warm%20natural%20light%2C%20editorial%20fashion%20flat%20lay%20photography%20with%20organic%20composition&width=400&height=400&seq=cat-img-sets&orientation=squarish',
  },
  {
    id: 'underwear',
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20minimalist%20undergarments%20and%20essentials%20neatly%20folded%20on%20a%20warm%20terracotta%20surface%2C%20soft%20natural%20lighting%20with%20gentle%20shadows%2C%20clean%20editorial%20product%20photography%20style%20with%20neutral%20beige%20and%20cream%20tones&width=400&height=400&seq=cat-img-underwear&orientation=squarish',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sportswear%20jerseys%20and%20athletic%20tops%20displayed%20on%20wooden%20hangers%2C%20clean%20minimalist%20background%20in%20warm%20neutral%20beige%20tones%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%20with%20sophisticated%20composition&width=400&height=400&seq=cat-img-jersey&orientation=squarish',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Curated%20fashion%20accessories%20collection%20including%20watches%20sunglasses%20and%20jewelry%20arranged%20on%20a%20marble%20tray%2C%20warm%20golden%20tones%2C%20soft%20natural%20light%2C%20editorial%20luxury%20product%20photography%20style%20with%20minimal%20elegant%20composition&width=400&height=400&seq=cat-img-accessories&orientation=squarish',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20and%20canvas%20bags%20including%20tote%20and%20crossbody%20styles%20displayed%20on%20a%20warm%20wooden%20pedestal%2C%20soft%20natural%20lighting%2C%20neutral%20cream%20and%20tan%20tones%2C%20editorial%20luxury%20product%20photography%20with%20clean%20minimalist%20composition&width=400&height=400&seq=cat-img-bags&orientation=squarish',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20neatly%20coiled%20and%20arranged%20on%20a%20warm%20stone%20surface%2C%20soft%20natural%20lighting%20with%20warm%20brown%20and%20tan%20tones%2C%20editorial%20fashion%20accessory%20photography%20style%20with%20minimal%20elegant%20composition&width=400&height=400&seq=cat-img-belts&orientation=squarish',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20perfume%20bottles%20arranged%20artistically%20on%20a%20warm%20cream%20marble%20surface%2C%20soft%20golden%20natural%20light%2C%20delicate%20dried%20flowers%20nearby%2C%20editorial%20beauty%20product%20photography%20style%20with%20warm%20neutral%20palette&width=400&height=400&seq=cat-img-perfumes&orientation=squarish',
  },
  {
    id: 'other-stuff',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20curated%20mix%20of%20lifestyle%20products%20including%20tech%20accessories%20and%20home%20items%20arranged%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20neutral%20beige%20and%20cream%20tones%2C%20editorial%20lifestyle%20product%20photography%20style%20with%20organic%20composition&width=400&height=400&seq=cat-img-other&orientation=squarish',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';